import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const londonbetColors: ThemeTailwindType = {
    '--primary': '357 100% 57%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#003652',
    secondary: '#ff2733',
    tertiary: '#0077b5',
    dark: '#002538',
    shade1: '#535353',
    shade2: '#626262',
    shade3: '#E1E1E1',
    shade4: '#E9E9E9',
    shade5: '#F0F0F0',
    shade6: '#F8F8F8',
    textDark: '#444444',
    textTertiary: '#0077B5',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.tertiary,

        borderColor: colorPalette.tertiary,
        borderColorSecondary: colorPalette.tertiary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.tertiary,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.dark,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.white,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#002538',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#FF2733',
        buttonTxtColor: '#ffffff',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
